import { makeObservable, override, computed } from 'mobx'
import { task } from 'mobx-task'
import Job from 'jobs/Job'
import ModalViewModel from 'infra/ModalViewModel'
import JobStore from 'jobs/JobStore'
import { AlertFactory, AlertState } from 'alerts/Alert'
import CouponStore from 'billing/CouponStore'
import Coupon from 'billing/models/Coupon'

/**
 * Dialog for removing applied coupons from jobs.
 */
export default class RemoveCouponAsAdminViewModel extends ModalViewModel {
  constructor(
    private readonly job: Job,
    private readonly jobStore: JobStore,
    public readonly couponStore: CouponStore,
    private readonly newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  /**
   * Shows the modal.
   */
  @override
  show() {
    super.show()
  }

  @computed
  get couponDisplay() {
    const coupon = this.couponStore.byCode(this.job.couponCodes) || Coupon.none

    return `${coupon.code}-${coupon.discount}`
  }

  removeCouponAsAdmin = task.resolved(async () => {
    const alert = this.newAlert()

    try {
      await this.jobStore.removeCouponAsAdmin(this.job)
    } catch (error) {
      alert.fromError(error).autoDismiss().show()

      throw error
    }

    this.close()
    alert
      .saying('Coupon removed!', 'The coupon was removed successfully.')
      .withState(AlertState.Success)
      .autoDismiss()
      .show()
  })
}
